import request from '@/util/request';

/**
 * 版权交易资讯 接口
 * @Author Hubx
 */

// 免登录 获取详情
export function articleInfo(id) {
  return request({
    url: `/tran/TranArticle/ua/` + id,
    method: 'get'
  });
}

// 免登录 获取列表
export function articleList(params) {
  return request({
    url: `/tran/TranArticle/ua/list`,
    method: 'get',
    params: params
  });
}

// 免登录 保存记录
export function articleSave(data) {
  return request({
    url: `/tran/TranArticle/ua/saveOrUpdate`,
    method: 'post',
    data: data
  });
}
